import React from 'react';
import { Grid } from '@mui/material';
import EngagementDeciles from './engagementDeciles';
import EngagementSpecialty from './engagementSpecialty';

function DecileSpecialty() {
    return (
        <Grid item xs={12}>
            <Grid container spacing={3}>
                {/* Physician Engagement by Deciles */}
                <Grid item xs={6}>
                    <EngagementDeciles />
                </Grid>

                {/* Physician Engagement by Specialty */}
                <Grid item xs={6}>
                    <EngagementSpecialty />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default DecileSpecialty;
